import React from 'react';
import Layout from '../../Components/Layout';
import { useLanguage } from '../../context/LanguageContext';
import { FaCookieBite, FaQuestion, FaListAlt, FaUsersCog, FaTools, FaEdit, FaPhoneAlt } from 'react-icons/fa';

export default function Cookie() {
    const { translations } = useLanguage();
    const t = translations.policies?.cookie || {};

    return (
        <Layout>
            {/* Hero Section */}
            <div className="breadcrumb-bar breadcrumb-bg-01 text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title mb-2">{t.breadcrumb?.title}</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center mb-0">
                                    <li className="breadcrumb-item"><a href="/"><i className="isax isax-home5"></i> {translations.policies?.breadcrumb?.home}</a></li>
                                    <li className="breadcrumb-item">{translations.policies?.breadcrumb?.pages}</li>
                                    <li className="breadcrumb-item active" aria-current="page">{t.breadcrumb?.title}</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="policy-content bg-white p-4 rounded shadow-sm">
                                <div className="text-center mb-5">
                                    <div className="d-inline-block p-4 rounded-circle bg-light-200 mb-3">
                                        <FaCookieBite className="text-primary" size={40} />
                                    </div>
                                    <h1 className="mb-2">{t.title}</h1>
                                    <p className="text-muted">{t.lastUpdated}</p>
                                    <div className="divider-center mb-4">
                                        <span className="divider-line"></span>
                                    </div>
                                </div>

                                {/* Introduction */}
                                <div className="policy-section mb-5">
                                    <h3 className="mb-3 d-flex align-items-center">
                                        <FaCookieBite className="text-primary me-2" size={24} />
                                        {t.introduction?.title}
                                    </h3>
                                    <p className="lead">{t.introduction?.content}</p>
                                </div>

                                {/* What Are Cookies */}
                                <div className="policy-section mb-5 p-4 bg-light-200 rounded">
                                    <h3 className="mb-3 d-flex align-items-center">
                                        <FaQuestion className="text-primary me-2" size={24} />
                                        {t.whatAreCookies?.title}
                                    </h3>
                                    <p>{t.whatAreCookies?.content}</p>
                                </div>

                                {/* Types of Cookies */}
                                <div className="policy-section mb-5">
                                    <h3 className="mb-3 d-flex align-items-center">
                                        <FaListAlt className="text-primary me-2" size={24} />
                                        {t.typesOfCookies?.title}
                                    </h3>
                                    <p>{t.typesOfCookies?.content}</p>
                                    
                                    <div className="cookie-types mt-4">
                                        <div className="row">
                                            {t.typesOfCookies?.items?.map((item, index) => (
                                                <div key={index} className="col-md-6 mb-4">
                                                    <div className="card h-100 border-0 shadow-sm">
                                                        <div className="card-body">
                                                            <div className="d-flex align-items-center mb-3">
                                                                <div className="me-3">
                                                                    <span className="badge rounded-pill bg-primary text-white p-2">
                                                                        <FaCookieBite size={14} />
                                                                    </span>
                                                                </div>
                                                                <h4 className="card-title mb-0">{item.title}</h4>
                                                            </div>
                                                            <p className="card-text">{item.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                {/* Third Party Cookies */}
                                <div className="policy-section mb-5 p-4 bg-light-200 rounded">
                                    <h3 className="mb-3 d-flex align-items-center">
                                        <FaUsersCog className="text-primary me-2" size={24} />
                                        {t.thirdPartyCookies?.title}
                                    </h3>
                                    <p>{t.thirdPartyCookies?.content}</p>
                                </div>

                                {/* Managing Cookies */}
                                <div className="policy-section mb-5">
                                    <h3 className="mb-3 d-flex align-items-center">
                                        <FaTools className="text-primary me-2" size={24} />
                                        {t.managingCookies?.title}
                                    </h3>
                                    <p>{t.managingCookies?.content}</p>
                                    
                                    <div className="alert alert-info mt-4">
                                        <div className="d-flex">
                                            <div className="me-3">
                                                <i className="isax isax-info-circle fs-24 text-primary"></i>
                                            </div>
                                            <div>
                                                <p className="mb-0">Most browsers allow you to manage cookie settings. These settings can usually be found in the 'Options', 'Settings' or 'Preferences' menu of your browser.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Changes */}
                                <div className="policy-section mb-5 p-4 bg-light-200 rounded">
                                    <h3 className="mb-3 d-flex align-items-center">
                                        <FaEdit className="text-primary me-2" size={24} />
                                        {t.changes?.title}
                                    </h3>
                                    <p>{t.changes?.content}</p>
                                </div>

                                {/* Contact */}
                                <div className="policy-section mb-4">
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-body p-4">
                                            <h3 className="mb-3 d-flex align-items-center">
                                                <FaPhoneAlt className="text-primary me-2" size={24} />
                                                {t.contact?.title}
                                            </h3>
                                            <p>{t.contact?.content}</p>
                                            <div className="contact-info mt-3">
                                                <div className="d-flex align-items-center mb-2">
                                                    <div className="me-3">
                                                        <span className="badge bg-primary-soft text-primary p-2">
                                                            <i className="isax isax-sms5 fs-18"></i>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <strong>Email:</strong> {t.contact?.email}
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <div className="me-3">
                                                        <span className="badge bg-primary-soft text-primary p-2">
                                                            <i className="isax isax-call-calling5 fs-18"></i>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <strong>Phone:</strong> {t.contact?.phone}
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <span className="badge bg-primary-soft text-primary p-2">
                                                            <i className="isax isax-map-15 fs-18"></i>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <strong>Address:</strong> {t.contact?.address}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
} 